// Главное меню
const mainMenuEn = {
	// Надпись про то, что находитесь в такой-то школе
	youAreInSchool: "You're in school right now",
}

export default mainMenuEn
